import { useAppSelector } from 'hooks/useAppSelector';
import {
  ConnectedPrimaryQuoteBlotterItem,
  ConnectedPrimaryTradeBlotterItem,
  ConnectedSecondaryOrdersBlotterItem,
  ConnectedSecondaryTradeBlotterItem,
} from 'layouts/main/sp-header/navigation/blotters-items';
import { Divider } from 'layouts/main/sp-header/navigation/components/divider';
import { DropdownSectionTitle } from 'layouts/main/sp-header/navigation/components/dropdown-section-title';
import { NavigationDropdown } from 'layouts/main/sp-header/navigation/NavigationDropdown';
import { createSelector } from 'reselect';
import type { RoutePath } from 'state/router';
import {
  isQuoteBlotterVisible,
  isSecondaryOrderBlotterVisible,
  isSecondaryTradeBlotterVisible,
  isTradeBlotterVisible,
} from 'state/selectors/common/router';

const associatedRoutes: RoutePath[] = [
  '/quote-blotter',
  '/trade-blotter',
  '/secondary-orders-blotter',
  '/secondary-trade-blotter',
];

const isPrimarySectionVisibleSelector = createSelector(
  isQuoteBlotterVisible,
  isTradeBlotterVisible,
  (quoteBlotter, tradeBlotter) => quoteBlotter || tradeBlotter,
);

const isSecondarySectionVisibleSelector = createSelector(
  isSecondaryOrderBlotterVisible,
  isSecondaryTradeBlotterVisible,
  (secondaryOrder, secondaryTrade) => secondaryOrder || secondaryTrade,
);

const isVisibleSelector = createSelector(
  isPrimarySectionVisibleSelector,
  isSecondarySectionVisibleSelector,
  (isPrimary, isSecondary) => isPrimary || isSecondary,
);
export function BlottersMenu() {
  const isPrimarySectionVisible = useAppSelector(isPrimarySectionVisibleSelector);
  const isSecondarySectionVisible = useAppSelector(isSecondarySectionVisibleSelector);
  const isVisible = useAppSelector(isVisibleSelector);

  return (
    <NavigationDropdown
      associatedRoutes={associatedRoutes}
      isVisible={isVisible}
      e2e="blotters-menu"
      toggleE2e="blotters-dropdown-toggle"
      menuE2e="blotters-dropdown-menu"
      label="appHeader.navigation.blotters"
    >
      {isPrimarySectionVisible && (
        <>
          <DropdownSectionTitle title="primaryMarket" />
          <ConnectedPrimaryQuoteBlotterItem />
          <ConnectedPrimaryTradeBlotterItem />
        </>
      )}
      {isPrimarySectionVisible && isSecondarySectionVisible && <Divider />}
      {isSecondarySectionVisible && (
        <>
          <DropdownSectionTitle title="secondaryMarket" />
          <ConnectedSecondaryOrdersBlotterItem />
          <ConnectedSecondaryTradeBlotterItem />
        </>
      )}
    </NavigationDropdown>
  );
}
